import { cn } from '@/lib/cn';

interface ArticleContentProps extends React.HTMLAttributes<HTMLDivElement> {
  containerClassName?: string;
}

export const ArticleContent = ({
  children,
  className,
  containerClassName,
  ...props
}: ArticleContentProps) => {
  return (
    <article
      className={cn(
        'px-4 py-12.5 lg:px-6 lg:pt-25 lg:pb-10',
        containerClassName,
      )}
      {...props}
    >
      <div
        className={cn(
          'prose-gray prose prose-h1:text-secondary prose-h1:text-3xl prose-h2:text-2xl prose-h3:text-xl prose-h4:text-lg prose-h5:text-base prose-h6:text-sm prose-headings:mt-6 prose-headings:mb-4 prose-headings:font-medium mx-auto mb-12 lg:mb-24',
          className,
        )}
      >
        {children}
      </div>
    </article>
  );
};
